module.exports = __webpack_public_path__ + "img/timeline_handschrift_01.fced50a9.png";